import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './mf.html';

const mfConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('mf', {
		title:                      'MF Field',
		template,
		icon:                       'fa fa-magic',
		tableView:                  (/** @type {any} */ data) => (data ? data.name : ''),
		onEdit:     /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {any} */ UIActionService,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ Notification,
		) => {
			$scope.methods = UIActionService.methods;
			$scope.colGetId = (/** @type {any} */ col) => {
				let returnValue;

				if (angular.isObject(col) && 'kid' in col) {
					returnValue = col.kid;
					if (col.linker_kid !== '0') {
						returnValue += `|${col.linker_kid}`;
					}
				}
				return returnValue;
			};

			$scope.colGetKey = (
				/** @type {any} */ col,
			) => ($scope.component || $scope.$parent.component).ktable.cols.findIndex(
				(/** @type {any} */ c) => c.kid === col.kid && c.linker_kid === col.linker_kid,
			);

			$scope.colGetName = (/** @type {any} */ col) => {
				let returnValue = col.name;

				if (col.linker_kid !== '0') {
					returnValue += ` :: ${col.linker_info.name}`;
				}

				return returnValue;
			};

			$scope.hasColRepre = () => {
				let returnValue = false;

				const component = $scope.component || $scope.$parent.component;
				if (component.kdata.mf_order) {
					for (const c of component.ktable.cols) {
						if (c.kid === component.kdata.mf_order) {
							returnValue = true;
						}
					}
				}

				return returnValue;
			};

			$scope.jsonEditorOptions = {
				mode:        'code',
				modes:       [],
				mainMenuBar: false,
				onError:     (/** @type {any} */ error) => {
					Notification.warning({
						title:   $translate.instant('error.title'),
						message: error.toString(),
					});
				},
				statusBar:   false,
			};

			$scope.toggleSelection = (/** @type {any} */ col) => {
				const index = $scope.colGetKey(col);
				const component = $scope.component || $scope.$parent.component;

				if (index >= 0) {
					component.ktable.cols.splice(index, 1);
				}
				else {
					component.ktable.cols.push(col);
				}
			};

			$scope.tmpDefaultValue = angular.copy($scope.component.defaultValue);

			$scope.$watch('tmpDefaultValue', () => {
				$scope.component.defaultValue = $scope.tmpDefaultValue.map((/** @type {any} */ v) => ({
					kid:  v.kid,
					name: v.name,
				}));
			}, true);

			$scope.definedby = [];
		},
		children:                   false,
		selectable:                 true,
		settings:                   {
			autofocus:    false,
			clearOnHide:  false,
			defaultValue: [],
			disabled:     false,
			input:        true,
			inputType:    'text',
			tableView:    true,
			label:        'MF Field',
			key:          'mfField',
			placeholder:  '',
			mode:         'label',
			hidden:       false,
			hideLabel:    false,
			kdata:        {
				class_kid:  undefined,
				create:     true,
				kid:        undefined,
				lastForm:   true,
				linker_kid: '0',
				method:     [],
				mf_custom:  null,
				mf_dico:    false,
				mf_order:   'ALL',
				mf_suggest: undefined,
				path:       [],
				pictures:   false,
				submit:     true,
				type_kid:   'K_NODE;STRING',
				uploadFile: false,
			},
			ktable:       {
				node:    undefined,
				cols:    [],
				options: {
					actions:     {
						delete:  true,
						refresh: true,
						update:  true,
						upload:  false,
					},
					height:      200,
					mode:        'normal',
					packet_size: 50,
					parent:      undefined,
					tree:        true,
				},
				query:   {},
			},
			conditional:  {
				show: undefined,
				when: undefined,
				eq:   '',
			},
			options:      {
				icon:                 false,
				uniqueKid:            false,
				displayAddBtn:        true,
				displayValues:        true,
				displayExpandButton:  true,
				displaySuggestBtn:    true,
				displaySuggestOnLoad: null,
				focusSearch:          null,
			},
			event:        {
				onSelect: undefined,
			},
			validate:     {
				card:   '0-N',
				custom: '',
			},
		},
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/mf/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/mf/data.html',
			},
			{
				name:     'Table',
				template: 'kform/components/mf/ktable.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/mf/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
			/** @type {ReturnType<import('~/scripts/services/ui-action.service').UIActionService>} */ UIActionService,
		) => {
			if ($scope.component.options) {
				$scope.component.options.createKid = $scope.component.kdata?.kid;
				$scope.component.options.dico = $scope.component.kdata?.mf_dico || false;
			}
			$scope.mfSelect = (
				/** @type {Function} */ callback,
				/** @type {any} */ item,
				/** @type {Event} */ event,
			) => {
				if (typeof callback === 'function') {
					callback(event, item);
				}
				else if (callback in UIActionService.methods) {
					$timeout(() => {
						$timeout(() => {
							UIActionService.methods[callback](item);
						});
					});
				}
				else if (typeof callback === 'string') {
					const custom = ''.concat(callback, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
						item,
					});
				}
			};
		},
	});
};

export default angular.module('app')
	.config(mfConfig);
